<template>
  <div class="layout">
    <Layout>
      <header-main
        :ewimg="ewimg"
        :config="config"
        class="header-container"
        v-if="showHeader"
      />
      <mobile-header
        :ewimg="ewimg"
        class="mobile-header-container"
      ></mobile-header>
      <div class="main-container" :class="[showHeader ? '' : 'noheader']">
        <app-main />
      </div>
      <footer-main
        :config="config"
        class="footer-container"
        v-if="showFooter"
      />
      <mobile-footer
        :config="config"
        class="mobile-footer-container"
      />
    </Layout>
  </div>
</template>

<script>
import { getPublicData } from '../api/getData.js'
import { HeaderMain, MobileHeader, FooterMain, MobileFooter, AppMain } from './components'
export default {
  name: 'layout',
  components: {
    HeaderMain,
    MobileHeader,
    FooterMain,
    MobileFooter,
    AppMain
  },
  data () {
    return {
      ewimg: [],
      config: {},
      showHeader: true,
      showFooter: true
    }
  },
  created () {
    this.getPublicInfo()
  },
  mounted () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      let pathStr = this.$route.fullPath
      let pathArr = pathStr.split('/')
      if (pathArr[1] === 'login' || pathArr[1] === 'register' || pathArr[1] === 'forget' || pathArr[1] === 'success') {
        this.showHeader = false
        this.showFooter = false
      } else {
        this.showHeader = true
        this.showFooter = true
      }
    },
    async getPublicInfo () {
      let result = await getPublicData()
      this.config = result.webconfig
      this.ewimg = result.ewimg
    }
  }
}
</script>

<style scoped>
  .layout{
    width: 100%;
    height: 100%;
    background: #f5f7f9;
    position: relative;
    overflow: hidden;
  }
  .header-container{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 900;
    width: 100%;
    height: 148px;
    padding: 0;
    background-color: #ffffff;
    box-shadow: 0px 12px 79px 0px rgba(0, 0, 0, 0.21);
    border-radius: 0;
  }
  .mobile-header-container{
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 900;
    width: 100%;
    height: 50px;
    padding: 0;
    background-color: #ec6420;
    border-radius: 0;
  }
  .main-container{
    margin-top: 148px;
  }
  .main-container.noheader{
     margin-top: 0;
  }
  .footer-container{
    padding: 0;
  }
  .mobile-footer-container{
    display: none;
    padding: 0;
  }
  @media screen and (max-width: 1200px){
    .header-container{
      display: none;
    }
    .mobile-header-container{
      display: block;
    }
    .main-container{
      margin-top: 50px;
    }
    .main-container.noheader{
      margin-top: 50px;
    }
    .footer-container{
      display: none;
    }
    .mobile-footer-container{
      display: block;
    }
  }
</style>
